module.exports = __webpack_public_path__ + "static/media/menuCocktailDinner.273e7aca.jpg";